"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Unstable_Grid2_1 = require("@mui/material/Unstable_Grid2");
const PREFIX = "CardRadioGroup";
exports.classes = {
    item: `${PREFIX}-item`
};
exports.Root = (0, styles_1.styled)("div")(() => ({
    padding: "0px",
    [`& .${Unstable_Grid2_1.grid2Classes.container}`]: {
        display: "flex",
        flexFlow: "row wrap",
        margin: "-12px"
    },
    [`& .${exports.classes.item}`]: {
        margin: "1px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NhcmQtcmFkaW8tZ3JvdXAvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUM5QyxpRUFBMkU7QUFFM0UsTUFBTSxNQUFNLEdBQUcsZ0JBQWdCLENBQUM7QUFFbkIsUUFBQSxPQUFPLEdBQUc7SUFDckIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxDQUFDO0lBQ3ZDLE9BQU8sRUFBRSxLQUFLO0lBQ2QsQ0FBQyxNQUFNLDZCQUFXLENBQUMsU0FBUyxFQUFFLENBQUMsRUFBRTtRQUMvQixPQUFPLEVBQUUsTUFBTTtRQUNmLFFBQVEsRUFBRSxVQUFVO1FBQ3BCLE1BQU0sRUFBRSxPQUFPO0tBQ2hCO0lBQ0QsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3RCLE1BQU0sRUFBRSxLQUFLO0tBQ2Q7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9